import { missingNativeBuild } from "../nativeError";
var ProtectedStore = Object.freeze({
  createItem: function createItem(_key, _value, _policy) {
    return Promise.reject(missingNativeBuild("ProtectedStore.createItem"));
  },
  getItem: function getItem(_key, _reason, _policy) {
    return Promise.reject(missingNativeBuild("ProtectedStore.getItem"));
  },
  updateItem: function updateItem(_key, _value, _reason, _policy) {
    return Promise.reject(missingNativeBuild("ProtectedStore.updateItem"));
  },
  deleteItem: function deleteItem(_key, _reason, _policy) {
    return Promise.reject(missingNativeBuild("ProtectedStore.deleteItem"));
  }
});
export {
  ProtectedStore
};
//# sourceMappingURL=unavailable.js.map
